import { createFileRoute } from '@tanstack/react-router';
import { doNothing } from 'remeda';

import config from '@@config';
import { userListSearchParams } from '@@containers/users/userListSearchParams';
import { userTabQueries } from '@@containers/users/userTabQueries';
import { getContentLocale } from '@@scripts/store/settings/useSettingsStore';

import { UserListPage } from './-components/UserListPage';

export const Route = createFileRoute('/_authenticated/users/')({
    validateSearch: userListSearchParams,
    // A new search makes a new match, which runs the loader again
    loaderDeps: ({ search }) => userListSearchParams.parse(search),
    beforeLoad: ({ search }) => ({
        // Built on every load, so the options follow the content language as well as the search
        userQueries: userTabQueries(
            {
                q: search.q,
                serviceUser: false,
                size: config.list.itemsPerPage,
                page: (search.page ?? 1) - 1,
            },
            getContentLocale(),
        ),
    }),
    // Every tab's query runs, for their counts
    loader: ({ context }) => {
        context.queryClient.query(context.userQueries.all).catch(doNothing());
        context.queryClient.query(context.userQueries.internal).catch(doNothing());
        context.queryClient.query(context.userQueries.external).catch(doNothing());
    },
    component: UserListPage,
});
